import React from 'react';
import PropTypes from 'prop-types';

const House = ({ className, checked }) => (
    <svg
        width="56px"
        height="56px"
        viewBox="0 0 56 56"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} ${
            checked
                ? 'path__stroke__checked polyline__stroke__checked'
                : 'path__stroke polyline__stroke'
        }`}
    >
        <title>Maison</title>
        <desc>Created with Sketch.</desc>
        <g
            id="assets"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            opacity="0.6"
            strokeLinejoin="round"
        >
            <g id="House" strokeWidth="2" stroke="#393939">
                <g id="Page-1" transform="translate(8.000000, 13.000000)">
                    <polyline id="Stroke-1" points="-7.27196081e-14 13 20 0 40 13" />
                    <path
                        d="M6,9 L6,31 L16,31 L16,22 C16,21.447 16.448,21 17,21 L23,21 C23.553,21 24,21.447 24,22 L24,31 L34,31 L34,9"
                        id="Stroke-3"
                    />
                </g>
            </g>
        </g>
    </svg>
);

House.displayName = 'House';

House.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
};

/**
 * House Functional Component.
 */
export default House;
